import { Color } from './color';
/**
 * □
 */
export const HollowSquare = (options, context) => {
    return Color(Object.assign({ colorAttribute: 'stroke', symbol: 'square' }, options), context);
};
HollowSquare.props = Object.assign({ defaultMarker: 'hollowSquare' }, Color.props);
//# sourceMappingURL=hollowSquare.js.map